<template>
  <div class="syj_BlackthreePrize syj_bg">
    <title class="commom-title"><span>三等奖</span></title>
    <div class="syjprice_money"><span>奖金</span>￥{{ prize_third }}</div>
    
    <List :columns="columns" :data="prizethreelist" :isEmpty="prize_third == 0">
      <template v-slot:name="scope">
        <div class="cell_name">
          <img :src="scope.row.avatar_url" />
          <div>{{ scope.row.name }}</div>
        </div>
      </template>
      
      <template v-slot:award_number="scope">
        <div class="cell_award_number">
          {{ scope.row.award_number }}
        </div>
      </template>
      
      <template v-slot:order_commitment="scope">
        <div class="cell_order_commitment">
          {{ scope.row.order_commitment }}
        </div>
      </template>
    </List>
  </div>
</template>
<script>
import List from '@/components/core/List'

export default {
  name: "BlackthreePrize",
  components: {
    List,
  },
  data() {
    return {
      columns: [{
        label: '获奖姓名',
        prop: 'name',
      }, {
        label: '中奖号码',
        prop: 'award_number',
      }, {
        label: '下单承诺',
        prop: 'order_commitment',
      }]
    };
  },
  
  props: {
    prize_third: {
      type: [Number, String],
      default: "",
    },
    prizethreelist: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="less" scoped>
.syjprice_money {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  font-weight: 700;
  margin-top: 30px;
  color: #fff;
  span {
    font-size: 24px;
    margin-top: 4px;
    color: #dd0e19;
  }
}

.cell_name {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100px;
  
  img {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 10px;
  }
}
</style>
<style lang="less">
.syj_BlackthreePrize {
  ul {
    li.lunkong {
      width: calc(100% - 64px);
      justify-content: center;
    }
    
    display: flex;
    flex-direction: column;
    padding: 0 15px;
    margin-top: 25px;
    
    li {
      .name {
        display: flex;
        align-items: center;
        justify-content: center;
        
        .namethree {
          width: 26px;
          height: 26px;
          overflow: hidden;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 50%;
          background: #fff;
          margin-right: 10px;
        }
      }
      
      font-weight: lighter;
      font-size: 16px;
      height: 50px;
      // border-bottom: 1px solid;
      color: #fff;
      // -o-border-image: linear-gradient(90deg, #363fb5, #363fb5, #363fb5) 1;
      // border-image: linear-gradient(90deg, #363fb5, #363fb5, #363fb5) 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      text-align: center;
      padding: 0 32px;
      
      &:nth-child(2n-1) {
        background: #363fb5;
      }
      
      &.first {
        font-size: 18px;
        // border-top: 1px solid;
        color: #fff;
        background-image: linear-gradient(90deg, #dd0e19, #dd0e19, #dd0e19);
        height: 46px;
      }
      
      & span {
        width: calc(100% / 3);
      }
    }
  }
}
</style>
